module.exports = __webpack_public_path__ + "img/female_age.61c79dd7.png";